const carouselItems = [
  {
    title: '暑期档必追剧单',
    desc: '炎炎夏日窝在家里吹空调追剧才是正经事！我们为你精选了今年暑期档最值得期待的十部大剧，从古装仙侠到都市甜宠，承包你的整个夏天。',
    tag: '编辑推荐',
    img: 'https://readdy.ai/api/search-image?query=Summer%20entertainment%20collage%20with%20colorful%20drama%20posters%2C%20bright%20sunny%20atmosphere%2C%20beach%20and%20palm%20trees%20subtle%20background%2C%20vibrant%20warm%20colors%2C%20festive%20summer%20vibe%2C%20cinematic%20composition%2C%20high%20quality&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    title: '悬疑烧脑专场',
    desc: '反转再反转，让你猜不到结局的高分悬疑剧合集。国产悬疑近几年佳作频出，从刑侦探案到心理惊悚，每一部都让你欲罢不能熬夜追完。',
    tag: '专题策划',
    img: 'https://readdy.ai/api/search-image?query=Mystery%20and%20thriller%20theme%20collage%20with%20dark%20atmospheric%20elements%2C%20magnifying%20glass%20and%20clues%2C%20noir%20style%20lighting%2C%20deep%20blue%20and%20shadow%20tones%2C%20cinematic%20mystery%20visual%2C%20high%20quality%20composition&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    title: '韩剧热播追踪',
    desc: '最新韩剧追更日历来了！从浪漫爱情到职场复仇，从奇幻穿越到家庭温情，每部都让人上头。同步更新进度实时追踪，追剧党再也不怕落下进度。',
    tag: '热播追踪',
    img: 'https://readdy.ai/api/search-image?query=Korean%20drama%20theme%20collage%2C%20romantic%20and%20dramatic%20scenes%2C%20cherry%20blossom%20and%20cityscape%20mix%2C%20soft%20pastel%20color%20palette%2C%20emotional%20cinematic%20style%2C%20modern%20Korean%20aesthetic%2C%20high%20quality&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    title: '经典重温剧场',
    desc: '那些年我们追过的经典好剧，值得一刷再刷。从武侠经典到年代大戏，每一部都是时代的记忆。高清修复版本上线，重温当年的感动与热血。',
    tag: '经典回顾',
    img: 'https://readdy.ai/api/search-image?query=Nostalgic%20classic%20Chinese%20drama%20theme%20collage%2C%20vintage%20film%20aesthetic%2C%20retro%20cinema%20elements%2C%20warm%20sepia%20and%20golden%20tones%2C%20old%20movie%20posters%20style%2C%20classic%20cinematography%20feel%2C%20high%20quality&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
          <p className="mt-2 text-sm text-foreground-500">精选策划，发现更多好剧</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.title}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={item.title}
                  title={`${item.title} - 窝窝影院`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-xs text-accent-600 bg-accent-50 px-2.5 py-0.5 rounded-full">{item.tag}</span>
                </div>
                <h3 className="text-base font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}